<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.modify_real_name')" class="nav-bar page-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-save" @click="save()">{{$t("setting.save")}}</span>
      </template>
    </van-nav-bar>
    <div class="page-body">
      <van-cell-group class="form-card">
        <van-field
          v-model="name"
          :readonly="userInfo.name !== ''"
          :label="$t('setting.name')"
          :placeholder="$t('setting.name_place')"
        />
      </van-cell-group>
      <p class="tips">{{$t("setting.name_tip")}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(this.userInfo.name){
        this.$toast(this.$t("setting.repect"));
        return true;
      }
      if(this.name === "" || this.name === null || this.name === undefined){
        this.$toast.fail(this.$t("setting.name_place"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{name:this.name},
        url: 'user_set_name'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  padding: 10px 16px 0;
}

.form-card {
  overflow: hidden;
}

.tips {
  padding: 0 6px;
  margin-top: 18px;
  font-size: 30px;
  line-height: 42px;
  color: #dc2037;
}

.nav-save {
  color: #6667e8;
  font-size: 30px;
  font-weight: 700;
}

.nav-back {
  color: #8795ad;
}

::v-deep .page-nav {
  background: #fff;
}

::v-deep .page-nav .van-nav-bar__title {
  color: #000;
}

::v-deep .page-nav::after {
  border-bottom: 1px solid #ededed;
}

::v-deep .form-card .van-cell {
  padding: 24px 20px;
  font-size: 35px;
  line-height: 80px;
}

::v-deep .form-card .van-field__label {
  color: #000;
}

::v-deep .form-card .van-field__control {
  color: #000;
}

::v-deep .form-card .van-field__control::placeholder {
  color: #b0b0b0;
}
</style>
